import serviceBase from 'app/Services/serviceBase'
import cmsActions from 'app/Components/CMS/CMSActions'

const getMembers = async (fireDepartmentId, errorSnackBarActions) => {
  try {
    let url = `${window._env_.COMMUNITY_API_URL}/iar-members/list/byFireDepartmentId`
    const res = await serviceBase.get(`${url}/${fireDepartmentId}`)

    if (res.status === 200) {
      return { MemberList: res.data, moreThanOneMember: res.data.length > 0 ? true : false }
    }

    return { MemberList: [], moreThanOneMember: false }
  } catch (err) {
    errorSnackBarActions.setOpen(true)
    return { MemberList: null, moreThanOneMember: false }
  }
}

const createMemberSession = async (
  members,
  value,
  errorSnackBarActions,
  setMemberlistDialog,
  setIarMember
) => {
  try {
    if (!value) {
      return errorSnackBarActions.setOpen(true, 'Please select a member!')
    }

    const { memberId } = getMemberId(members, value)

    if (!memberId) {
      return errorSnackBarActions.setOpen(true)
    }
    let impersonateUrl = `${window._env_.COMMUNITY_API_URL}/iar-members/impersonate`
    const res = await serviceBase.get(`${impersonateUrl}/${memberId}`)
    if (res.status === 200) {
      const newIarMember = await cmsActions.getIarMember()
      setIarMember(newIarMember)
      setMemberlistDialog(false)
    }
  } catch (error) {
    errorSnackBarActions.setOpen(true)
    console.error(error)
  }
}

const getMemberId = (members, value) => {
  const member = members.filter((member) => member.fullName === value)
  if (member.length === 1) {
    return { memberId: member[0].memberId }
  } else {
    return { memberId: null }
  }
}

export { getMembers, createMemberSession }
